import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { requestNotificationRefresh } from './notification_events';
import { formatNotificationAddress } from './notifications';

export const NotificationOpen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);
  const [error, setError] = useState('');
  const locationAddress = formatNotificationAddress(notification?.location_address);

  useEffect(() => {
    let cancelled = false;
    if (!/^\d+$/.test(id || '')) {
      setError('Invalid notification.');
      return undefined;
    }
    fetch(`/apinotifications/${encodeURIComponent(id)}/open`, { method: 'POST' })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Notification unavailable');
        return data;
      })
      .then(data => {
        if (cancelled) return;
        requestNotificationRefresh();
        if (data.target_path) navigate(data.target_path, { replace: true, state: { id: data.entity_id } });
        else setNotification(data);
      })
      .catch(openError => !cancelled && setError(openError.message));
    return () => { cancelled = true; };
  }, [id, navigate]);

  return (
    <div className="notificationsPage pageSection">
      <div className="notificationsPanel">
        {error ? <><h1>Notification unavailable</h1><p className="notificationError">{error}</p></> : notification ? <><h1>{notification.title}</h1>{notification.location_code && <span className="notificationLocationCode">Location: {notification.location_code}</span>}{locationAddress && <p className="notificationLocationAddress">{locationAddress}</p>}<p className="notificationBodyFull">{notification.body}</p></> : <p role="status">Opening notification…</p>}
        {(error || notification) && <button type="button" className="mainButton" onClick={() => navigate('/notifications')}>Back to notifications</button>}
      </div>
    </div>
  );
};
